import { AppState } from '@/types/AppState.types';
import { LicensingFeatures } from '../slices/app';

export const getSelectedBlock = (state: AppState) => state.app.selectedBlock;
export const getSelectedBlockId = (state: AppState) =>
  state.app.selectedBlock.id;
export const getBlocksPayload = (state: AppState) => state.app.blocks.payload;
export const getBlocksError = (state: AppState) => state.app.blocks.error;
export const getBlocksLoading = (state: AppState) => state.app.blocks.loading;

export const getLicenseFeature = (
  state: AppState,
  feature: keyof LicensingFeatures
) => state.app.features[feature];

export const getPersonalizationEnabled = (state: AppState) =>
  getLicenseFeature(state, 'personalization')?.maxAudiences;

export const getButtonCount = (state: AppState) =>
  getPersonalizationEnabled(state) ? 6 : 5;
